
import Vue from 'vue';
export default Vue.extend({
  props: {
    src: {
      type: String,
      default: 'https://lorempic.jvm-neckar.net/1200x800/DEEBD4/0F3228?text=mood&texture=cross',
    },
    alt: {
      type: String,
      default: 'Image Alt text',
    },
    title: {
      type: String,
      default: 'Image Title',
    },
    ratio: {
      type: String,
      default: '3to2',
    },
    caption: {
      type: String,
    },
    sizes: {
      type: String,
      default: 'sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw 3xl:100vw 4xl:100vw',
    },
    focus: {
      type: String,
    },
    noRatio: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  methods: {
    setImageLoaded(): void {
      this.isLoaded = true;
    },
  },
  computed: {
    focalPoint(): any {
      return this.focus ? { filters: { focal: this.focus } } : { smart: true };
    },
    dimensions(): any {
      if (this.noRatio) return undefined;

      const dimensions = this.ratio.split('to');

      return {
        width: dimensions[0],
        height: dimensions[1],
      };
    },
  },
});
